"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var types_1 = require("types");
var GenericInviteModal_1 = require("components/modals/GenericInviteModal");
var participantsActionts = require("@caddigital/sok-reducers/lib/actions/bid/participants");
var toastActions = require("@caddigital/sok-reducers/lib/actions/toast");
require("./addParticipant.scss");
var mapStateToProps = function (state) {
    return {
        userGroups: state.bid.userGroups,
        add: state.bid.participants.add
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    toggleModal: function () { return dispatch(participantsActionts.toggleAddParticipant()); },
    selectItem: function () { return false; },
    updateEmails: function (uuid) { return function (emails) {
        return dispatch(participantsActionts.addParticipantsUpdateRow(uuid, emails));
    }; },
    updateLanguage: function (uuid, language) {
        dispatch(participantsActionts.addParticipantsLanguage(uuid, language));
    },
    addNewRow: function (row) {
        return dispatch(participantsActionts.addParticipantsAddRow(row));
    },
    removeRow: function (uuid) {
        return dispatch(participantsActionts.addParticipantsRemoveRow(uuid));
    },
    sendInvitations: function (bid, briefcase, invitations) {
        return dispatch(participantsActionts.addParticipantsRequest(bid, briefcase, invitations));
    },
    addNewToast: function (title, message, type) {
        return dispatch(toastActions.addNewToast(title, message, type));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
//#region Types
var statePropsExtractable = (0, types_1.extractReturnType)(exports.mapStateToProps);
var dispatchPropsExtractable = (0, types_1.extractReturnType)(exports.mapDispatchToProps);
//#endregion
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), recompose_1.pure);
exports.default = enhance(function (props) { return (React.createElement(GenericInviteModal_1.default, { isOpen: props.add.isOpen, modalTitle: (0, translation_1.getLocalization)('bid/participants/addModal/title'), messageHeader: (0, translation_1.getLocalization)('bid/participants/addModal/headerText1'), messageContent: (0, translation_1.getLocalization)('bid/participants/addModal/headerText2'), messageNote: (0, translation_1.getLocalization)('bid/participants/addModal/headerNote'), inviteText: (0, translation_1.getLocalization)('components/modals/genericInvitationModal/add'), status: props.add.status, inviteRows: props.add.fields, items: props.userGroups.list, toggleModal: props.toggleModal, selectItem: props.selectItem, updateEmails: props.updateEmails, addNewRow: function (row) {
        if (props.userGroups.list.length > 0) {
            var group = props.userGroups.list[0];
            row.group = group.id;
            props.addNewRow(row);
        }
    }, removeRow: props.removeRow, addNewToast: props.addNewToast, sendInvitations: function () {
        return props.sendInvitations(props.currentBid, props.currentBriefcase, props.add.fields);
    }, errors: props.add.errors, groupStatus: props.userGroups.status, exportAddress: "".concat(__APIBASEURL__, "api/project/").concat(props.currentBid.project, "/members") })); });
